export default "__VITE_ASSET__2f4d4078__"